import React from 'react'
import TopBar from '../Layouts/TopBar'
import Sidebar from '../Layouts/Sidebar'

import AddProjects from './AddProjects';

function CreateProject() {

    return (


        <>
            <TopBar />
            <main>
                <div class="container">
                    <div class="row g-4">

                        <div className="col-lg-3">
                            <Sidebar />
                        </div>

                        <div className="col-md-8 col-lg-6 vstack gap-4">
                            {/* Create a project START */}
                            <div className="card">
                                {/* Title START */}
                                <div className="card-header border-0 pb-0">
                                    <h1 className="h4 card-title mb-0">Create Project</h1>
                                </div>

                                <div className="card-body">
                                    <AddProjects />
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* Container END */}
            </main>






        </>
    )
}

export default CreateProject